interface LocalizedErrorMessage {
  errorCode?: string;
  en?: string;
  ko?: string;
}

export const extractErrorCode = (error: any): string | undefined => {
  if (error?.data?.errorCode) {
    return error.data.errorCode;
  }

  const message = error?.data?.message;
  if (!message) return undefined;

  if (Array.isArray(message)) {
    const firstMessage = message[0];
    if (typeof firstMessage === "object" && firstMessage !== null) {
      return firstMessage.errorCode;
    }
    return undefined;
  }

  if (typeof message === "object" && message !== null) {
    return (message as LocalizedErrorMessage).errorCode;
  }

  return undefined;
};

export const extractErrorMessage = (
  error: any,
  defaultMessage: string,
  language: string = "en"
): string => {
  const message = error?.data?.message;
  if (!message) return defaultMessage;

  if (Array.isArray(message)) {
    const firstMessage = message[0];
    if (typeof firstMessage === "object" && firstMessage !== null) {
      return (language === "ko" ? firstMessage.ko : firstMessage.en) || defaultMessage;
    }
    return typeof firstMessage === "string" ? firstMessage : defaultMessage;
  }

  if (typeof message === "object" && message !== null) {
    const localizedMessage = message as LocalizedErrorMessage;
    return (language === "ko" ? localizedMessage.ko : localizedMessage.en) || defaultMessage;
  }

  if (typeof message === "string") {
    return message;
  }

  return defaultMessage;
};
